import type { FC, ReactNode } from 'react'
import type { LegalSection } from '@/components/landing/legal-page'

import LegalPage from '@/components/landing/legal-page'

const SECTIONS: LegalSection[] = [
    {
        id: 'scope',
        heading: 'What this policy covers',
        paragraphs: [
            'This policy explains how the Rare Frequency Works website and its free browser tools handle information. When you use DOCSCRUB or Morpho Radar, the disclosures in those apps and their store listings also apply.'
        ]
    },
    {
        id: 'files',
        heading: 'Files you choose in our tools',
        paragraphs: [
            'Our image tools work inside your browser. The images and photos you choose are processed on your device and are not uploaded to us. Everything the tools need, including the HEIC converter and the PDF builder, loads from this website.',
            'Files you save, such as a compressed image or a new PDF, go straight to your device.'
        ]
    },
    {
        id: 'hosting',
        heading: 'Hosting and security',
        paragraphs: [
            'Our hosting provider runs this website. Like any website, it handles technical details needed to deliver pages and keep the service secure, such as IP addresses, browser type and request logs, under its own policies.'
        ]
    },
    {
        id: 'statistics',
        heading: 'Visitor statistics',
        paragraphs: [
            'We count visits with privacy-friendly statistics provided by our host. They show totals such as page views, the pages visited, where visitors came from, country, browser and device type.',
            'These statistics do not use cookies, do not follow you to other websites, and are not used to build a profile of you.'
        ]
    },
    {
        id: 'ads',
        heading: 'Advertising',
        paragraphs: [
            'This website does not show ads and does not load advertising scripts. The free version of DOCSCRUB may show ads inside the app, as described in its store listings.'
        ]
    },
    {
        id: 'support',
        heading: 'Support messages',
        paragraphs: [
            'When you use our contact form, we store your name, email address, topic and message, and send a copy to our team by email so we can reply. We use them only to answer you and to troubleshoot.',
            'Emails sent from this website may include standard measurement of whether they were opened and which links were clicked.',
            'Please do not send private documents, passwords or full payment details. You can ask us to see or delete your messages through the same form.'
        ]
    },
    {
        id: 'purchases',
        heading: 'Purchases',
        paragraphs: [
            'DOCSCRUB Premium is bought inside the Android app through Google Play or inside the Windows app through the Microsoft Store. DOCSCRUB for Amazon Fire is available from Amazon. These stores handle payment details under their own terms, and we never see your full card details.'
        ]
    },
    {
        id: 'radar',
        heading: 'Morpho Radar',
        paragraphs: [
            'Morpho Radar runs on its own address. Its free simulator needs no wallet. If you pay for a live query, the payment is made from your wallet on the Base network, and blockchain transactions are public by design. Read the Radar documentation for details.'
        ]
    },
    {
        id: 'changes',
        heading: 'Changes to this policy',
        paragraphs: [
            'If we change how we handle information, we will update this page and the date at the top.'
        ]
    }
]

const PrivacyPage: FC = (): ReactNode => (
    <LegalPage
        seoTitle='Privacy policy'
        description='How the Rare Frequency Works website and free browser tools handle information. Your files stay on your device.'
        eyebrow='Rare Frequency Works'
        title='Privacy policy'
        tagline='Your files stay with you. Here is everything else.'
        updated='November 2, 2026'
        sections={SECTIONS}
    />
)

export default PrivacyPage
